/** 
 * @namespace Breakpoints
 * @memberof Promega.Shell
 * @description The screen width breakpoints used for responsive layouts on the site. Provided as a reference
 * in order to reduce the need for hard-coding screen sizes into other scripts on the site.
 */

/**
 * @typedef Breakpoint
 * @memberof Promega.Shell.Breakpoints
 * @description An object containing details about a screen width breakpoint for use in responsive design.
 * @type {object}
 * @property {number} size The width, in pixels, of the breakpoint.
 * @property {MediaQueryList} query A [MediaQueryList]{@link https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList} object to which you can attach event listeners for when the query's validity changes.
 */

/**
 * @property {Promega.Shell.Breakpoints.Breakpoint} GENE
 * @memberof Promega.Shell.Breakpoints
 * @description The "gene" breakpoint. Matches screen sizes >=320px.
 */
const GENE = {
    size: 320,
    query: null
},

/**
 * @property {Promega.Shell.Breakpoints.Breakpoint} CHROMOSOME
 * @memberof Promega.Shell.Breakpoints
 * @description The "chromosome" breakpoint. Matches screen sizes >=480px.
 */
CHROMOSOME = {
    size: 480,
    query: null
},

/**
 * @property {Promega.Shell.Breakpoints.Breakpoint} GENE
 * @memberof Promega.Shell.Breakpoints
 * @description The "nucleus" breakpoint. Matches screen sizes >=600px.
 */
NUCLEUS = {
    size: 600,
    query: null
},

/**
 * @property {Promega.Shell.Breakpoints.Breakpoint} GENE
 * @memberof Promega.Shell.Breakpoints
 * @description The "cell" breakpoint. Matches screen sizes >=768px.
 */
CELL = {
    size: 768,
    query: null
},

/**
 * @property {Promega.Shell.Breakpoints.Breakpoint} GENE
 * @memberof Promega.Shell.Breakpoints
 * @description The "colony" breakpoint. Matches screen sizes >=1024px.
 */
COLONY = {
    size: 1024,
    query: null
},

/**
 * @property {Promega.Shell.Breakpoints.Breakpoint} GENE
 * @memberof Promega.Shell.Breakpoints
 * @description The "organism" breakpoint. Matches screen sizes >=1280px. Note: this is the default maximum width of page content on the site.
 */
ORGANISM = {
    size: 1280,
    query: null
};

if (typeof window !== "undefined") {
    GENE.query = window.matchMedia("(min-width: " + GENE.size + "px)");
    CHROMOSOME.query = window.matchMedia(`(min-width: ${CHROMOSOME.size}px)`);
    NUCLEUS.query = window.matchMedia("(min-width: " + NUCLEUS.size + "px)");
    CELL.query = window.matchMedia("(min-width: " + CELL.size + "px)");
    COLONY.query = window.matchMedia("(min-width: " + COLONY.size + "px)");
    ORGANISM.query = window.matchMedia("(min-width: " + ORGANISM.size + "px)");
}

// API

export {GENE, CHROMOSOME, NUCLEUS, CELL, COLONY, ORGANISM};
